<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters v-model="filterOptions" style="margin-right: 45px" @click="refresh" />
            <DropdownColumns v-model="fields" class="customize" />
          </div>
          <b-table
            id="shop-groups-table"
            :busy.sync="isBusy"
            show-empty
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :hover="true"
            :striped="true"
            stacked="md"
            v-model="copy"
            :items="provider"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            @row-clicked="rowClicked"
            tbody-tr-class="tr-pointer"
            v-columns-resizable="{afterResize: columnsWidthChanged}"
          >
            <template v-slot:empty="scope">
              <div class="text-center">{{ $t(scope.emptyText) }}</div>
            </template>

            <template v-slot:head(etenant_id)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(name)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(eshop_ids)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(allow_cross_payments)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(warning_email_addresses)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(block_email_addresses)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(efirewall_ruleset_id)="data">{{ $t(data.label) }}</template>

            <template v-slot:head(selected)>
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid">
                <input type="checkbox" @click.stop @change="selectAll" v-model="checkAll" />
                <span></span>
              </label>
            </template>

            <template v-slot:cell(etenant_id)="data">
              <span v-if="data.value.to">
                <router-link :to="`/tenants/${data.value.to}`">{{ data.value.name }}</router-link>
              </span>
              <span v-else>{{ data.value.name }}</span>
            </template>

            <template v-slot:cell(efirewall_ruleset_id)="data">
              <span v-if="data.value.to">
                <router-link :to="`/firewalls/${data.value.to}`">{{ data.value.name }}</router-link>
              </span>
              <span v-else>{{ data.value.name }}</span>
            </template>
            <template v-slot:cell(eshop_ids)="data">
              [
              <span v-for="(item, index) in data.value" :key="index">
                <span v-if="item.to">
                  <router-link :to="`/shops/${item.to}`">{{ item.name }}</router-link>
                </span>
                <span v-else>{{ item.name }}</span>,
              </span>
              ]
            </template>

            <template v-slot:cell(selected)="data">
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid">
                <input type="checkbox" @click.stop :value="data.item.eid" v-model="selected" />
                <span></span>
              </label>
            </template>
          </b-table>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <BulkActionSelect
                  v-model="bulkAction"
                  :options="bulkActionOptions"
                  variant="light"
                  class="mr-2"
                  size="sm"
                  v-if="selected.length"
                />
                <b-button
                  @click.stop="applySelected()"
                  size="sm"
                  class="mr-2 refresh"
                  variant="light"
                  v-if="selected.length"
                  :disabled="!bulkAction"
                >{{$t('Apply')}}</b-button>
                <span class="pagination-sep" v-if="selected.length"></span>
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{(currentPage-1) * perPage + 1}}</span>
                    <span slot="end">{{currentPage * perPage}}</span>
                    <span slot="total">{{totalRows}}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="$root.$emit('bv::refresh::table', 'shop-groups-table')"
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";
import BulkActionSelect from "@/components/BulkActionSelect";

export default {
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters,
    BulkActionSelect
  },
  name: "shopGroups",
  mixins: [tableMixin],
  data: function() {
    return {
      tableName: "shop-groups",

      bulkAction: null,
      bulkActionOptions: [
        {
          text: "Allow Cross Payments",
          field: "allow_cross_payments",
          value: true
        },
        {
          text: "Prevent Cross Payments",
          field: "allow_cross_payments",
          value: false
        }
      ],

      filterOptions: [
        {
          field: "tenant_id",
          multiple: false,
          placeholder: "Tenant",
          trackBy: "eid",
          label: "brand_name",
          translate: false,
          store: "tenants",
          options: [],
          selected: []
        },
        {
          field: "shop_ids",
          multiple: true,
          placeholder: "Shops",
          trackBy: "eid",
          label: "name",
          store: "shops",
          translate: false,
          options: [],
          selected: []
        },
        {
          field: "firewall_ruleset_id",
          multiple: false,
          placeholder: "Firewall",
          trackBy: "eid",
          label: "name",
          store: "firewalls",
          translate: false,
          options: [],
          selected: []
        },
        {
          field: "allow_cross_payments",
          multiple: false,
          placeholder: "Cross Payments",
          options: [
            { name: "Cross Payments Enabled", value: true },
            { name: "Cross Payments Disabled", value: false }
          ],
          selected: []
        }
      ],
      isBusy: false,
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "selected",
          selected: false,
          ignore: true,
          class: "mw-select",
          dpIgnore: true
        },
        {
          key: "eid",
          label: "Id",
          sortable: false,
          class: "d-none",
          ignore: true
        },
        {
          key: "etenant_id",
          label: "Tenant",
          ignore: true,
          sortable: true,
          class: ""
        },
        { key: "name", sortable: true, class: "" },
        { key: "eshop_ids", label: "Shops", ignore: true, class: "" },
        {
          key: "allow_cross_payments",
          sortable: true,
          ignore: true,
          class: ""
        },
        { key: "warning_email_addresses", ignore: true, class: "d-none" },
        { key: "block_email_addresses", ignore: true, class: "d-none" },
        {
          key: "efirewall_ruleset_id",
          label: "Firewall",
          ignore: true,
          class: "d-none"
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      selected: [],
      copy: null,
      addLabel: "Add group"
    };
  },
  watch: {
    selected(val) {
      if (val.length != this.copy.length) {
        this.checkAll = false;
      }
    }
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "shop-groups-table");
    },
    selectAll() {
      this.selected = [];
      this.copy.forEach(item => {
        if (this.checkAll) {
          this.selected.push(item.eid);
        }
      });
    },
    applySelected() {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const bulkData = {
        field: this.bulkAction.field,
        value: this.bulkAction.value,
        ids: this.selected
      };

      this.$store.dispatch("shopGroup/bulkAction", bulkData).finally(() => {
        loading.close();
        this.allSelected = false;
        this.selected = [];
        this.refresh();
      });
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        let sortBy = this.sortBy;
        if (sortBy == "etenant_id") sortBy = "tenant_id";
        paginationData.sortBy = [sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach(item => {
        if (item.selected.length) {
          exactFields.push(item.field);
          if (item.trackBy) {
            const tmp = [];
            item.selected.forEach(el => {
              tmp.push(el[item.trackBy]);
            });
            exactValues.push(tmp);
          } else {
            exactValues.push(item.selected);
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      this.$store
        .dispatch("shopGroup/fetch", paginationData)
        .then(resp => {
          this.totalRows = resp.data.total;

          let shopGroupsRows = resp.data.rows;
          let tenantIDs = {};
          let shopIDs = {};
          let firewallIDs = {};

          shopGroupsRows.forEach(item => {
            if (item.etenant_id) {
              tenantIDs[item.etenant_id] = true;
            }
            if (item.efirewall_ruleset_id) {
              firewallIDs[item.efirewall_ruleset_id] = true;
            }
            if (item.eshop_ids) {
              shopIDs[item.eshop_ids] = true;
            }
          });

          Promise.all([
            this.$store.dispatch("cacheOnDemand/fetch", {
              key: "tenants",
              ids: Object.keys(tenantIDs)
            }),
            this.$store.dispatch("cacheOnDemand/fetch", {
              key: "shops",
              ids: Object.keys(shopIDs)
            }),
            this.$store.dispatch("cacheOnDemand/fetch", {
              key: "firewalls",
              ids: Object.keys(firewallIDs)
            })
          ]).then(([tenantsData, shopsData, firewallData]) => {
            shopGroupsRows.forEach((item, index) => {
              if (item.etenant_id) {
                const data = tenantsData[item.etenant_id];
                if (data) {
                  item.etenant_id = {
                    to: item.etenant_id,
                    name: data.brand_name
                  };
                } else {
                  item.etenant_id = {
                    to: null,
                    name: item.etenant_id
                  };
                }
              }
              if (item.eshop_ids) {
                const tmp = [];
                for (let i = 0; i < item.eshop_ids.length; i += 1) {
                  const rid = item.eshop_ids[i];
                  const data = shopsData[rid];
                  if (data) {
                    tmp.push({ to: rid, name: data.name });
                  } else {
                    tmp.push({ to: null, name: rid });
                  }
                }
                item.eshop_ids = tmp;
              }
              if (item.efirewall_ruleset_id) {
                const data = firewallData[item.efirewall_ruleset_id];
                if (data) {
                  item.efirewall_ruleset_id = {
                    to: item.efirewall_ruleset_id,
                    name: data.name
                  };
                } else {
                  item.efirewall_ruleset_id = {
                    to: null,
                    name: item.efirewall_ruleset_id
                  };
                }
              }
            });
            callback(shopGroupsRows);
          });
        })
        .catch(err => {
          this.$bvToast.toast(
            this.$t(err.message),
            errorConf(this.$t("Error"))
          );
          this.totalRows = 0;
          callback([]);
        })
        .finally(() => {
          loading.close();
        });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    rowClicked(item, index, event) {
      this.$router.push("/shop-groups/" + item.eid);
    },
    redirect() {
      this.$router.push("/shop-groups/0");
    }
  }
};
</script>

<style lang="scss" scoped>
</style>

